export default {
    tagsView: {
        refresh: '刷新',
        closeOthers: '关闭其他',
        closeAll: '关闭所有',
        close: '关闭',
        allTags: '所有标签页'
    },
    route: {
        index: 'index',
        appointment: 'appointment',
        dispatch: 'dispatch',
        dispatchOrder: 'dispatchOrder',
        carrierManage: 'carrierManage',
        receiptManage: 'receiptManage',
        equipment: 'equipment',
        passage: 'passage',
        orderPanel: 'orderPanel',
        revocationCarrierHistory: 'revocationCarrierHistory'
    }
};